/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap';

import { TableProtocolFields } from './components/TableProtocolFields';
import FieldsConfigService from '../service/index';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

const FieldsConfig = () => {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [validationEntities, setValidationEntities] = useState([]);

  useEffect(() => {
    const baseEntities = [
      {
        displayName: 'Protocolo',
        pluralDisplayName: 'Protocolos',
        entityName: 'protocol',
        entityNameUpper: 'PROTOCOL'
      },
      {
        displayName: 'Oportunidade',
        pluralDisplayName: 'Oportunidades',
        entityName: 'opportunity',
        entityNameUpper: 'OPPORTUNITY'
      },
      {
        displayName: 'Conta',
        pluralDisplayName: 'Contas',
        entityName: 'account',
        entityNameUpper: 'ACCOUNT'
      },
      {
        displayName: 'Contato',
        pluralDisplayName: 'Contatos',
        entityName: 'contact',
        entityNameUpper: 'CONTACT'
      },
      {
        displayName: 'Lead',
        pluralDisplayName: 'Leads',
        entityName: 'lead',
        entityNameUpper: 'LEAD'
      }
    ];

    if (verifyRoles(['PRODUCT_CRM'])) {
      baseEntities.push({
        displayName: 'Produto',
        pluralDisplayName: 'Produtos',
        entityName: 'product',
        entityNameUpper: 'PRODUCT'
      });
    }

    setValidationEntities(baseEntities);
    setSelectedEntity(baseEntities[0]);
  }, []);

  useEffect(() => {
    if (!selectedEntity) return;
    getCustomFields(selectedEntity?.entityName);
  }, [selectedEntity]);

  const [fields, setFields] = useState();

  const showCustomFields = (entity) => {
    setSelectedEntity({ ...entity });
    getCustomFields(entity.entityName);
  };

  const getCustomFields = (entity) => {
    FieldsConfigService.getFields(entity)
      .then((response) => {
        setFields(response.data.data);
      })
      .catch(setFields(null));
  };

  return (
    <>
      {validationEntities[0]?.entityName ? (
        <>
          <SimpleHeader
            setCreate="/admin/fieldsConfig/form"
            name="Form validation"
            parentName="Forms"
            entityName={selectedEntity.displayName}
          />
          <Container className="mt--6" fluid>
            <Row>
              <div className="col">
                <div className="card-wrapper">
                  <Card>
                    <CardHeader>
                      <Row>
                        <Col>
                          <h2>Campos customizados</h2>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            display: 'grid',
                            gridTemplateColumns:
                              'repeat(auto-fit, minmax(min(7rem, 100%), 1fr))',
                            gap: '1rem',
                            width: '100%',
                            margin: '1rem'
                          }}
                        >
                          {' '}
                          {validationEntities.map((entity) => (
                            <Button
                              key={entity.displayName}
                              color="primary"
                              outline
                              className={
                                selectedEntity.displayName ===
                                entity.displayName
                                  ? 'active'
                                  : null
                              }
                              size="sm"
                              type="button"
                              title="Visualizar todos os tipos de registro desssa entidade"
                              onClick={() => showCustomFields(entity)}
                              style={{
                                margin: '0rem'
                              }}
                            >
                              {entity.displayName}
                            </Button>
                          ))}
                        </Col>
                      </Row>
                    </CardHeader>
                    <TableProtocolFields
                      fields={fields}
                      entityCurrent={selectedEntity?.entityNameUpper}
                    />
                  </Card>
                </div>
              </div>
            </Row>
          </Container>
        </>
      ) : (
        <Container>
          <Card>
            <CardBody>
              <h1 style={{ textAlign: 'center' }}>
                Desculpe, mas você não tem permissão para visualizar os campos
                customizados de cliente e protocolo
              </h1>
            </CardBody>
          </Card>
        </Container>
      )}
    </>
  );
};

export default FieldsConfig;
